export const isAuthenticated = (state) => {
    const token = state?.auth?.user?.token || state?.auth?.auth?.token;
    return !!token;
};